import React, { useEffect, useState, useRef } from 'react';
import { deleteChat, renameChat } from '../../redux/chat/actions.js';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Selection from './Selection.svg';
import styles from './Chat.module.css';

function Chat({ chat, onClick, isActive }) {
  const [showMenu, setShowMenu] = useState(false);
  const [isEditingName, setIsEditingName] = useState(false);
  const [newChatName, setNewChatName] = useState(chat.chat_name);
  const [displayChatName, setDisplayChatName] = useState(chat.chat_name);
  const user_id = useSelector((state) => state.user.user_id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuRef = useRef();
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  const handleDeleteChat = async (e) => {
    e.stopPropagation();
    console.log(chat.chat_id)
    dispatch(deleteChat(user_id, chat.chat_id));
    setShowMenu(false);
    navigate('/');
  };

  const handleRenameChat = async (e) => {
    e.stopPropagation();
    if (isEditingName) {
      dispatch(renameChat(user_id, chat.chat_id, newChatName));
      setDisplayChatName(newChatName); // Update the display name instantly
    }
    console.log(chat.chat_id)
    setIsEditingName(!isEditingName);
    setShowMenu(false);
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    if (inputValue.length > 20) {
      inputValue = inputValue.slice(0, 20);
    }
    setNewChatName(inputValue);
  };

  const handleInputBlur = (e) => {
    e.stopPropagation();
    handleRenameChat(e);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); 
      handleRenameChat(e);
    }
  };

  return (
    <div className={styles.layout}>
      <button
        className={`${styles.button} ${isActive ? styles.active : ''}`}
        onClick={() => onClick(chat.chat_id)}
      >
        {isEditingName ? (
          <input
            ref={inputRef}
            type="text"
            value={newChatName} 
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyDown={handleInputKeyDown}
            autoFocus
            className={`${styles.customInput} ${isEditingName ? styles.showInput : ''}`}
          />
        ) : (
          <p>{displayChatName}</p> 
        )}
        <div ref={menuRef}>
          <img
            src={Selection}
            alt="Selection"
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(prev => !prev);
            }}
            className={styles.icon}
          />
          {showMenu && (
            <div className={styles.options}>
              <button onClick={handleRenameChat}>
                {isEditingName ? 'Save' : 'Rename'}
              </button>
              <button className={styles.delete} onClick={handleDeleteChat}>
                Delete
              </button>
            </div>
          )}
        </div>
      </button>
    </div>
  );
}

export default Chat;
